import React from "react";

export const DownIcon = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.52897 9.91917L1.80511 4.19531L0.862305 5.13812L6.58616 10.862C6.59472 10.8705 6.60326 10.8791 6.61179 10.8876C6.81167 11.0876 7.00591 11.2819 7.1877 11.4206C7.39263 11.5769 7.65793 11.7239 8.00037 11.7239C8.34282 11.7239 8.60812 11.5769 8.81305 11.4206C8.99483 11.2819 9.18908 11.0876 9.38895 10.8876C9.39748 10.8791 9.40603 10.8705 9.41459 10.862L15.1384 5.13812L14.1956 4.19531L8.47178 9.91917C8.23623 10.1547 8.10599 10.283 8.00428 10.3606C8.00295 10.3616 8.00165 10.3626 8.00038 10.3635C7.9991 10.3626 7.9978 10.3616 7.99647 10.3606C7.89476 10.283 7.76452 10.1547 7.52897 9.91917Z"
      fill="#8D8D8D"
    />
  </svg>
);
